import { useCognitoAuth } from '@/contexts/cognitoAuthContext'
import { DashboardExperiments } from '@/experiments'
import { useFlag } from '@/hooks/useFlag'
import { useGetRolesByUser } from '@/queries/roles/useGetRolesByUser'
import { PremiumFeatures } from '@/services/types/premiumFeatures/premiumFeatures'
import { ROLES_IDS, RolesTypes } from '@/services/types/userRoles/mockRole'
import { usePremiumFeaturesPermissions } from '@/stores/permissions/premiumFeatures'

export const useToastIntegrationPermissions = () => {
  const { userId, isMarqiiUser } = useCognitoAuth()
  const userRoles = useGetRolesByUser(userId)
  const premiumFeaturesPermissions = usePremiumFeaturesPermissions()
  const hasToastPOSIntegrationFlag = useFlag(DashboardExperiments.toastPOSIntegration)

  const hasMenusFeature = premiumFeaturesPermissions.includes(PremiumFeatures.Menus)

  const hasToastPOSIntegrationFeature = hasToastPOSIntegrationFlag && hasMenusFeature

  const isFullControlRole =
    userRoles.data?.some(({ role }) => role.id === ROLES_IDS[RolesTypes.fullControl]) ?? false

  const isLocationManagerRole =
    userRoles.data?.some(({ role }) => role.id === ROLES_IDS[RolesTypes.locationManager]) ?? false

  const canSeeToastIntegration =
    hasToastPOSIntegrationFeature && (isMarqiiUser || isFullControlRole || isLocationManagerRole)

  const canManageToastIntegration =
    hasToastPOSIntegrationFeature && (isMarqiiUser || isFullControlRole)

  return {
    canSeeToastIntegration,
    canManageToastIntegration,
    isLoading: userRoles.isLoading,
  }
}
